import { KeyConstructor } from './keyConstructor.js'

const API_USAGES_KEY = 'api-usages'
const RATE_LIMIT_STATS_KEY = 'api-rate-limit-stats'

export const getApiUsageKey = KeyConstructor<never, never>(API_USAGES_KEY)
export const getRateLimitStatsKey = KeyConstructor<never, never>(
  RATE_LIMIT_STATS_KEY,
)
